import { alpha } from '@mui/material';

export const shape = {
    shadow: 'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px !important',
    popoverShadow: (theme) => `0px 0px 8px 0px ${alpha(theme.palette.neutral.main, 0.2)}`,
    boxShadow: (theme) => `0px 0px 8px 0px ${alpha(theme.palette.neutral.main, 0.08)}`,
};
